export default __webpack_public_path__ + "static/media/Product4.6db4570b.PNG";